import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    rechargeShow: false,
    loginStatus: false
  },
  mutations: {
    loginChange(state, val) {
      state.loginStatus = val;
    },
    rechargeChange(state) {
      state.rechargeShow = !state.rechargeShow;
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js